import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, search, nullsafe, assertUnreachable, first } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { obtenerTotalAPagar, onTransformEntregaRealizada, obtenerTipoPago, obtenerSaldoClienteDeEntrega } from "./logic";

export interface Props {
    state: models.ViajeAppIniciado;
    claveEntrega: string;
    onChange: (x: models.EntregaRealizadaViajeAppModel) => void;
}

export class PagoEntregaComp extends React.PureComponent<Props> {
    state = (props: Props) => props.state;
    claveEntrega = (props: Props) => props.claveEntrega;
    total = createSelectorRx(this.state, this.claveEntrega, (state, clave) => obtenerTotalAPagar(state, clave));
    tipoPago = createSelectorRx(this.state, this.claveEntrega, (state, clave) => obtenerTipoPago(state, clave));
    saldoCliente = createSelectorRx(this.state, this.claveEntrega, obtenerSaldoClienteDeEntrega);

    onTipoPagoChange = (tipo: models.TipoPagoEntregaDomicilio) => {
        this.props.onChange({
            ...first(this.props.state.model.EntregasRealizadas, x => x.ClaveUnica == this.props.claveEntrega)!,
            TipoPago: tipo
        });
    }

    componentDidMount() {
        const tipoPago = this.tipoPago(this.props);
        if (tipoPago == models.TipoPagoEntregaDomicilio.Credito) {
            kea.message("Crédito", "El cliente al que corresponde esta entrega maneja crédito", "info");
        }
    }

    render() {
        const total = this.total(this.props);
        const tipopago = this.tipoPago(this.props);
        const saldoCliente = this.saldoCliente(this.props);
        const saldoSuficiente = saldoCliente.saldo <= saldoCliente.limite;
        const creditoBloqueado = saldoCliente.creditoBloqueado;
        const esCredito = tipopago == models.TipoPagoEntregaDomicilio.Credito;
        return (
            <div>
                {
                    <div className={"alert alert-" + (!esCredito || (!creditoBloqueado && saldoSuficiente) ? "success" : "danger")}>

                        <label>Total a pagar:</label>
                        <h3>
                            {kea.formatCurrency(total.entregadas)}
                        </h3>

                        <label>Saldo / limite crédito:</label>
                        <h3>
                            {kea.formatCurrency(saldoCliente.saldo)}/{kea.formatCurrency(saldoCliente.limite)}
                        </h3>

                        {
                            (esCredito && creditoBloqueado) &&
                            <h3>
                                <span className="label label-danger">
                                    Linea de crédito bloqueada
                                </span>
                            </h3>
                        }

                        <kea.ButtonSelector
                            value={tipopago}
                            onChange={this.onTipoPagoChange}
                            items={[
                                {
                                    label: "Efectivo",
                                    value: models.TipoPagoEntregaDomicilio.Efectivo
                                }, {
                                    label: "Credito",
                                    value: models.TipoPagoEntregaDomicilio.Credito
                                }, {
                                    label: "Cheque",
                                    value: models.TipoPagoEntregaDomicilio.Cheque
                                }
                            ]}
                        />
                    </div>
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeapp/entrega/pago.tsx